import {active} from "./const.js";
import {md} from "./const.js";
import $ from "jquery";

$('.js-directionsHeader').on('click', function() {
  $(this).toggleClass(active);
  $(this).next('.js-directionsBody').slideToggle();
  return false;
});
